/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../messages';
// eslint-disable-next-line import/no-internal-modules
import Button from '@atlaskit/button/new';
var buttonStyles = css({
  margin: '0 auto',
  width: 'fit-content'
});
export var FeedbackButton = function FeedbackButton(_ref) {
  var onClick = _ref.onClick;
  return jsx("div", {
    css: buttonStyles
  }, jsx(Button, {
    onClick: onClick,
    appearance: "subtle"
  }, jsx(FormattedMessage, messages.common_give_feedback)));
};